import React from 'react'
import hipladeTemplate from '../../common/template'
import Feedback from '../components/Feedback'

function MyEventsFeedback() {
  return <Feedback />
}

export default hipladeTemplate(MyEventsFeedback)
